import React, { FC } from "react";
import { Checkbox as MuiCheckbox, CheckboxProps } from "@mui/material";

import IconCheckbox from "@icons/Checkbox";
import IconCheckboxChecked from "@icons/CheckboxChecked";

const Checkbox: FC<CheckboxProps> = (props) => (
  <MuiCheckbox
    {...props}
    icon={<IconCheckbox />}
    checkedIcon={<IconCheckboxChecked />}
  />
);

export default Checkbox;
